class TeacherNavigation {
	id = null;
	teacher_id = null;
	company = null;
	ship_type = null;
	start_date = null;
	end_date = null;
	rank_id = null;
	duration = null;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default TeacherNavigation;
